import { api, LightningElement, track } from "lwc";
import { logger } from "@devforce/trailhead-client-logger";

import { BooleanAttr, attrToBool, waitForPageSettled } from "tm/utils";

export default class extends LightningElement {
  @api videoId: string = undefined!;
  @api privacyEnabled: BooleanAttr = false;

  @track private height = 0;
  @track private width = 0;

  private didSetSize = false;

  private get src() {
    let domain = attrToBool(this.privacyEnabled)
      ? "youtube-nocookie.com"
      : "youtube.com";
    return `https://www.${domain}/embed/${this.videoId}`;
  }

  renderedCallback() {
    if (!this.didSetSize) {
      this.didSetSize = true;
      waitForPageSettled()
        .then(() => {
          let w = this.template.host.offsetWidth;
          let ratio = 0.5625;
          this.height = w * ratio;
          this.width = w;
        })
        .catch((e: Error) => logger.error(e.message));
    }
  }
}
